import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, pipe, switchMap, throwError } from 'rxjs';
import { mapHttpErrorToCcsResponseError, mapHttpResponseToCcsResponseError } from '../../store/utils';
import { HttpWrapperService } from './http-wrapper.service';
import { ApiUrlConfig, urls } from './api-urls';
import { EnvService } from '../env.service';

// TODO Consider moving to interceptor layer for any http wrapper
@Injectable({ providedIn: 'root' })
export class ApiHttpWrapperService extends HttpWrapperService {
  successFlagCheckBlackList: ApiUrlConfig[] = [];

  constructor(private httpClient: HttpClient, private envService: EnvService) {
    super(httpClient);
    // Found an API endpoint that returns success false for validation purposes
    this.successFlagCheckBlackList = [urls['validateProviderVisit']];
  }

  override defaultOptions: object = { observe: 'response' };

  override get<T>(url: string, options: object = {}): Observable<T> {
    return super.get<T>(url, options).pipe(this.processResponse('GET', url));
  }

  override post<T>(url: string, body: any, options: object = {}): Observable<T> {
    return super.post<T>(url, body, options).pipe(this.processResponse('POST', url));
  }

  override put<T>(url: string, body: any, options: object = {}): Observable<T> {
    return super.put<T>(url, body, options).pipe(this.processResponse('PUT', url));
  }

  override delete<T>(url: string, options: object = {}): Observable<T> {
    return super.delete<T>(url, options).pipe(this.processResponse('DELETE', url));
  }

  override patch<T>(url: string, body: any, options: object = {}): Observable<T> {
    return super.patch<T>(url, body, options).pipe(this.processResponse('PATCH', url));
  }

  isSuccessFlagCheckDisabled(requestMethod: string, url: string) {
    for (const entry of this.successFlagCheckBlackList) {
      const endpointRegex = new RegExp(entry.endpointRegex(this.envService));
      const requestUrl = url.split('?')[0];
      const match = requestUrl.match(endpointRegex);
      if (requestMethod === entry.httpMethod && match && requestUrl === match[0]) return true;
    }
    return false;
  }

  processResponse(requestMethod: string, url: string) {
    return pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => mapHttpErrorToCcsResponseError(error, requestMethod));
      }),
      switchMap((response: any) => {
        if (
          (!response.headers.get('Content-Type') ||
            !response.headers.get('Content-Type').toLowerCase().includes('text')) &&
          response.body &&
          !response.body.success &&
          !this.isSuccessFlagCheckDisabled(requestMethod, url)
        ) {
          console.log('SUCCESS FLAG ERROR: ', response);
          return throwError(() => mapHttpResponseToCcsResponseError(response, requestMethod, 'CcsApiSuccessFlagError'));
        } else {
          return of(response.body);
        }
      })
    );
  }
}
